/* ==========================================================================
   Kurv-drawer — Massage Care

   Filen hed oprindeligt cart-notification.js og styrede den lille
   "lagt i kurv"-boks. Den styrer nu drawer'en, men beholder elementnavnet
   <cart-notification>, så temaets eget product-form.js finder den uden
   ændringer.

   Butikken har flere slags tilføj-til-kurv-knapper: Dawns egen på almindelige
   produktsider og GemPages' på de byggede sider. Derfor lytter filen også
   direkte efter kald til /cart/add — så åbner drawer'en uanset hvilken knap
   kunden trykkede på.
   ========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartPath = (window.routes && window.routes.cart_url) || root + 'cart';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var TIMER_KEY = 'cv2dTimer';

  function drawer() { return document.getElementById('cv2-drawer'); }

  function sectionsUrl() {
    var u = new URL(root, window.location.origin);
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) u.searchParams.set('preview_theme_id', preview);
    u.searchParams.set('sections', SECTIONS);
    return u.toString();
  }

  function openAfterAdd() {
    setTimeout(function () {
      var d = drawer();
      if (!d || !d.refresh) return;
      if (window.location.pathname === cartPath) { window.location.reload(); return; }
      d.open();
      d.refresh();
    }, 150);
  }

  /* --- nedtælling --------------------------------------------------------
     Uret nulstilles når antallet af varer stiger, altså når kunden lægger
     noget nyt i kurven. Falder antallet, løber uret bare videre.
     Starttidspunktet gemmes lokalt, så uret ikke hopper tilbage til 10:00
     hver gang kunden klikker sig videre til en ny side. */
  var tick;
  function startTimer() {
    clearInterval(tick);
    var el = document.querySelector('[data-cv2d-timer]');
    if (!el) return;

    var out = el.querySelector('[data-cv2d-clock]');
    var minutes = parseInt(el.dataset.minutes, 10) || 10;
    var count = parseInt(el.dataset.count, 10) || 0;
    var now = Date.now();
    var store = null;

    try { store = JSON.parse(window.localStorage.getItem(TIMER_KEY) || 'null'); } catch (e) {}

    if (!store || count > store.count || now > store.start + minutes * 60000) {
      store = { start: now, count: count };
    } else {
      store.count = count;
    }
    try { window.localStorage.setItem(TIMER_KEY, JSON.stringify(store)); } catch (e) {}

    var end = store.start + minutes * 60000;

    function render() {
      var left = end - Date.now();
      if (left <= 0) { el.hidden = true; clearInterval(tick); return; }
      el.hidden = false;
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      out.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }
    render();
    tick = setInterval(render, 1000);
  }

  /* --- tryghedskarrusel i bunden af drawer'en ---------------------------- */
  var carousel;
  function startTrustCarousel() {
    clearInterval(carousel);
    var box = document.querySelector('[data-cv2d-carousel]');
    if (!box) return;
    var slides = Array.prototype.slice.call(box.querySelectorAll('.cv2d__trust-slide'));
    if (slides.length < 2) return;
    var wait = parseInt(box.dataset.interval, 10) || 3000;
    var i = 0;
    carousel = setInterval(function () {
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
    }, wait);
  }

  function afterRender() { startTimer(); startTrustCarousel(); }

  /* --- fang enhver tilføjelse til kurven, uanset hvilken app der laver den -- */
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(String(url)) && String(method).toUpperCase() === 'POST';
      var p = _fetch.apply(this, arguments);
      if (!isAdd) return p;
      return p.then(function (res) {
        if (res && res.ok) openAfterAdd();
        return res;
      });
    };
  }

  var _xopen = XMLHttpRequest.prototype.open;
  var _xsend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cv2Add = /\/cart\/add/.test(String(url)) && String(method).toUpperCase() === 'POST';
    return _xopen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (this.__cv2Add) {
      this.addEventListener('load', function () {
        if (self.status >= 200 && self.status < 300) openAfterAdd();
      });
    }
    return _xsend.apply(this, arguments);
  };

  if (customElements.get('cart-notification')) return;

  customElements.define('cart-notification', class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.panel = this.querySelector('.cv2d__panel');
      this.activeElement = null;
      this.bind();
    }

    setActiveElement(el) { this.activeElement = el; }

    getSectionsToRender() {
      return [{ id: 'cart-drawer' }, { id: 'cart-icon-bubble' }];
    }

    renderContents(parsed) {
      if (parsed && parsed.sections) this.applySections(parsed.sections);
      this.open();
    }

    applySections(sections) {
      if (!sections) return;
      var parser = new DOMParser();

      if (sections['cart-drawer']) {
        var src = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('.cv2d__inner');
        var dst = this.querySelector('.cv2d__inner');
        if (src && dst) dst.innerHTML = src.innerHTML;
      }

      if (sections['cart-icon-bubble']) {
        var doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        var srcB = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section');
        var dstB = document.getElementById('cart-icon-bubble');
        if (srcB && dstB) dstB.innerHTML = srcB.innerHTML;
      }

      afterRender();
    }

    busy(on) { this.classList.toggle('is-busy', !!on); }

    refresh() {
      var self = this;
      this.busy(true);
      return fetch(sectionsUrl())
        .then(function (r) { return r.json(); })
        .then(function (s) { self.applySections(s); })
        .catch(function () {})
        .then(function () { self.busy(false); });
    }

    changeQty(line, quantity) {
      var self = this;
      this.busy(true);
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (window.location.pathname === cartPath) { window.location.reload(); return; }
          return self.refresh();
        })
        .catch(function () { window.location.reload(); })
        .then(function () { self.busy(false); });
    }

    open() {
      this.classList.add('is-open');
      document.body.classList.add('cv2d-open');
      var p = this.panel;
      if (p) setTimeout(function () { p.focus(); }, 60);
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('cv2d-open');
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus();
    }

    bind() {
      var self = this;

      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-cv2d]');
        if (t) {
          var a = t.dataset.cv2d;
          if (a === 'close') { e.preventDefault(); self.close(); return; }
          if (a === 'minus' || a === 'plus' || a === 'remove') {
            e.preventDefault();
            var item = t.closest('.cv2d__item');
            var cur = item ? parseInt(item.querySelector('.cv2d__n').textContent, 10) : 0;
            var q = a === 'remove' ? 0 : (a === 'plus' ? cur + 1 : cur - 1);
            self.changeQty(parseInt(t.dataset.line, 10), Math.max(0, q));
            return;
          }
        }

        var bubble = e.target.closest('#cart-icon-bubble');
        if (bubble && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
          if (window.location.pathname === cartPath) return;
          e.preventDefault();
          self.open();
          self.refresh();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.classList.contains('is-open')) self.close();
      });

      var init = function () {
        /* Drawer'en renderes inde i header-sektionen. Flyttes den ud i bunden
           af <body>, kan hverken topbaren, headeren eller en app lægge sig
           oven på den. */
        if (self.parentElement !== document.body) document.body.appendChild(self);

        document.querySelectorAll('product-form').forEach(function (pf) {
          if (!pf.cartNotification) pf.cartNotification = self;
        });

        afterRender();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
      else init();
      setTimeout(init, 1200);
    }
  });
})();
